import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import CarListing from "../pages/CarListing";
import CarDetails from "../pages/CarDetails";
import Blog from "../pages/Blog";
import Restaurant from "../pages/Restaurant";
import Rentacar from "../pages/RentaCar";
import CarClinic from "../pages/CarClinic";
import ZuriWater from "../pages/ZuriWater";
import Barber from "../pages/Barber";
import BlogDetails from "../pages/BlogDetails";
import NotFound from "../pages/NotFound";
import Contact from "../pages/Contact";


const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<Home />} />
      <Route path="/rentacar" element={<Rentacar />} />
      <Route path="/about" element={<About />} />
      <Route path="/cars" element={<CarListing />} />
      <Route path="/cars/:slug" element={<CarDetails />} />
      <Route path="/blogs" element={<Blog />} />
      <Route path="/Restaurant" element={<Restaurant />} />
      <Route path="/car-clinic" element={<CarClinic />} />
      <Route path="/ZuriWater" element={<ZuriWater />} />
      <Route path="/Barber" element={<Barber />} />
      <Route path="/blogs/:slug" element={<BlogDetails />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
